/**
* Calcula el color de texto que contraste (negro o blanco)
* para un color de fondo hexadecimal dado.
*
* @param {string} hex - Color de fondo en formato hexadecimal (#RRGGBB)
* @returns {string} '#fff' si el fondo es oscuro, '#000' si el fondo es claro
*/
export const getContrastTextColor = (hex) => {
    const h = hex.replace(/^#/, '');
    const r = parseInt(h.substring(0, 2), 16);
    const g = parseInt(h.substring(2, 4), 16);
    const b = parseInt(h.substring(4, 6), 16);
    const [R, G, B] = [r, g, b].map(c => {
        const channel = c / 255;
        return channel <= 0.03928 ? channel / 12.92 : Math.pow((channel + 0.055) / 1.055, 2.4);
    });
    const L = 0.2126 * R + 0.7152 * G + 0.0722 * B;
    const contrastWhite = 1.05 / (L + 0.05);
    const contrastBlack = (L + 0.05) / 0.05;
    return contrastWhite > contrastBlack ? '#fff' : '#000';
};
